module.exports = __webpack_public_path__ + "img/5c362f02f2b3bb409f90b61d023984a9.png";